import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useUser } from 'features/auth';

// TODO: this should be possible to use in events/givings too
export const useGetListUserDisplayName = () => {
  const { t } = useTranslation();
  const {
    nodeUserData: { _id: currentUserId },
  } = useUser();

  return useCallback(
    (userId: string, name: string) => (userId === currentUserId ? t('listUserName', { name }) : name),
    [currentUserId, t],
  );
};
